"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShapeType = void 0;
var ShapeType;
(function (ShapeType) {
    ShapeType["Rectangle"] = "rectangle";
})(ShapeType || (exports.ShapeType = ShapeType = {}));
